import { AnimatePresence } from 'motion/react';
import { ModalBackdrop } from '../atoms';
import { CenteredModalProps } from '../modal.types';
import { ModalProvider } from '../provider';
import { CenteredModalBox } from './centered-modal-box';

const centeredModalClassName = 'wv-modal-container';

export const CenteredModal = ({
  children,
  disableCloseOnEscape,
  disableCloseOnOverlayClick,
  mountTarget,
  onClose,
  prepend,
  show,
  zIndex: overrideZIndex,
  ...rest
}: CenteredModalProps) => {
  return (
    <AnimatePresence>
      {show && (
        <ModalProvider
          className={centeredModalClassName}
          onClose={onClose}
          timeout={500}
          disableCloseOnEscape={disableCloseOnEscape}
          mountTarget={mountTarget}
          prepend={prepend}
          show={show}
          containerAttributes={{
            style: overrideZIndex ? `z-index: ${overrideZIndex};` : undefined,
          }}
        >
          <ModalBackdrop
            onClick={disableCloseOnOverlayClick ? undefined : onClose}
            show={show}
            omitOffset={!!mountTarget}
          />
          <CenteredModalBox {...rest}>{children}</CenteredModalBox>
        </ModalProvider>
      )}
    </AnimatePresence>
  );
};
